<template>
  <div class="container mt-2 mb-5">
    <div class="row">
      <div class="col md-12 text-center mt-5 mb-3">
        <img :src="require('@/assets/logo-main.webp')" class="img-fluid" width="250" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h3><span class="material-icons md-24 text-main-gradient">account_circle</span> Configuración Inicial</h3>
        <div class="welcome-message p-4 mb-4 ">
          <h4 class="text-center mb-3">Hola Dr./Dra.</h4>
          <p class="text-justify">
            Nos alegra tenerte aquí. Este es tu espacio digital donde podrás gestionar de forma segura, sencilla y
            profesional todos los aspectos clínicos de tus pacientes.
          </p>
          <ul class="list-unstyled mt-3">
            <li>✅ Registrar y consultar expedientes clínicos electrónicos.</li>
            <li>✅ Crear y almacenar notas médicas conforme a la NOM-004-SSA3-2012.</li>
            <li>✅ Gestionar antecedentes médicos, tratamientos y archivos adjuntos.</li>
            <li>✅ Emitir consentimientos informados digitales con respaldo legal.</li>
            <li>✅ Acceder a tus consultas desde cualquier lugar, con total confidencialidad.</li>
          </ul>
          <p class="text-justify mt-3">
            Este sistema ha sido diseñado para médicos independientes como tú, que buscan un aliado digital confiable
            para modernizar su consultorio y cumplir con la normativa mexicana en salud.
          </p>
          <blockquote class="blockquote text-center mt-4">
            <p class="mb-0">🩺 "Porque cada consulta importa, y cada dato cuenta."</p>
          </blockquote>
          <p class="text-center mt-4">
            <strong class="fw-bold">¡Comienza completando los siguientes datos y organiza tu primer expediente
              hoy!</strong>
          </p>
        </div>
      </div>
      <div class="col-md-12" v-if="!isVerified">
        <vs-alert>
          <h3>
            Por favor verifica tu cuenta
          </h3>
          <p>
            Revisa tu bandeja de entrada, te hemos enviado un correo electrónico para verificar tu cuenta de EscuMed.
            Si no has recibido ningún correo, haz clic en el botón de abajo para enviarlo nuevamente.
            Te enviaremos un correo de verificación otra vez.
          </p>
          <!-- <button type="submit" class="btn btn-primary  mt-2" @click="sendVerify()"><span class="spanButton">Send
              Verification</span></button> -->
          <vs-button color="rgb(59,222,200)" gradient block @click="sendVerify()">Enviar verificacion</vs-button>
        </vs-alert>
      </div>

      <div class="col-md-12 d-flex flex-column align-items-center text-center" ref="terminar">
        <p>Si ya has terminado de completar tus datos, haz clic en el botón de abajo para continuar.</p>
        <vs-button color="rgb(59,222,200)" gradient @click="verificarCompletitud">
          Continuar 🚀
        </vs-button>
      </div>

      <div class="col-md-4 mt-2 mb-5">

        <div class="card" ref="formulario1">
          <div class="card-body">
            <h4>Datos de usuario</h4>

            <div class="row">
              <div class="col-md-12 mb-3">
                <div v-if="previewImage" class="d-flex justify-content-center">
                  <img :src="previewImage" alt="Image Preview" ref="image" class="circular-image" />
                </div>
              </div>
              <vs-button v-if="selectedFile" @click="cropImage" color="rgb(59,222,200)" gradient block>Cortar y guardar
                imagen</vs-button>
              <div class="form-group">
                <label for="photoUrl">Logo</label>
                <input type="file" class="form-control mt-2" id="photoUrl" @change="handleFileUpload" accept=".jpg"
                  ref="fileInput" />
                <small class="form-text text-muted">
                  <strong>Nota:</strong> Este logo se mostrará como parte de tu sesión y en todos los documentos que se
                  expidan o impriman desde el sistema.
                </small>
              </div>
            </div>

            <div class="col-md-12">

              <div class="form-group mt-3">
                <label class="form-label">Nombre completo</label>
                <input type="text" class="form-control" placeholder="Nuevo nombre de usuario"
                  v-model.trim="newDisplayName" />
                <small class="form-text text-muted">
                  <strong>Nota:</strong> Tu nombre completo se mostrará en la parte superior de la pantalla y en todos
                  los documentos que se expidan o impriman desde el sistema.
                  Puedes incluir tu título profesional, por ejemplo: "Dra. Cynthia Medina".
                </small>
                <vs-button color="rgb(59,222,200)" gradient block @click="changeDisplayName()">💾 Guardar
                  Nombre</vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-2" ref="formulario2">
        <PersonalMedicoContacto v-if="currentUser" :personal_medico_id="currentUser.mainId" />
      </div>
      <div class="col-md-4 mt-2" ref="formulario3">
        <PersonalMedicoInfoAcademica v-if="currentUser" :personal_medico_id="currentUser.mainId" />
      </div>

    </div>



  </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import axios from 'axios';
  var config = require("@/config/api.json");
  const API = config.api;
  import Cropper from 'cropperjs';
  import 'cropperjs/dist/cropper.css';
  import {
    sendEmailVerification,
    EmailAuthProvider,
    updateEmail,
    reauthenticateWithCredential,
    updatePassword,
    updateProfile,
    getAuth
  } from "firebase/auth";
  import { auth } from "@/fb";
  import PersonalMedicoContacto from "@/views/PersonalMedicoContacto.vue";
  import PersonalMedicoInfoAcademica from "@/views/PersonalMedicoInfoAcademica.vue";
  import * as DriverModule from 'driver.js';

  const Driver = DriverModule.driver; // ✅ Esta es la función constructora que debes usar



  export default {
    name: "Settings",
    components: {
      PersonalMedicoContacto, PersonalMedicoInfoAcademica
    },
    computed: {
      isPostalCodeDisabled() {
        return this.location === 'xx';
      }
    },

    data() {
      return {
        currentUser: null,
        displayBilling: false,
        isVerified: false,
        userEmail: null,
        currentPassword: null,
        newPs: "",
        confirmPs: "",
        newDisplayName: "",
        selectedFile: null,
        previewImage: null,
        cropper: null,
        driver: null,
        tourIniciado: false,

      };
    },
    created() {
      const light = localStorage.getItem('light');
      if (light !== null) {
        document.body.classList.toggle('light-mode', light);
      } else {
        document.body.classList.toggle('light-mode', false);
      }
    },
    mounted() {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        if (user) {
          // this.isVerified = user.emailVerified;
          this.isVerified = true;
          // Puedes asignar el usuario a una variable en data si es necesario
          this.currentUser = user;
          if (user.photoURL) {
            this.previewImage = user.photoURL;
          }
          this.newDisplayName = user.displayName;
            // this.iniciarTour();

        }
      } catch (error) {
        console.error('Error loading user from localStorage:', error);
      }
    },
    methods: {
      ...mapActions(['updateDisplayName']),

      iniciarTour() {
        console.log("Iniciando el tour");
        alert("Iniciando el tour");
          if (this.tourIniciado) return;  // Ya inició, no hagas nada
            this.tourIniciado = true;

            if (this.driver) {
              this.driver.destroy();
              this.driver = null;
            }

        this.driver = new Driver({
          animate: true,
          opacity: 0.75,
          nextBtnText: 'Siguiente →',
          prevBtnText: '← Anterior',
          doneBtnText: 'Finalizar ✓',
          onDestroyed: () => {
           this.tourIniciado = false; // para permitir reiniciar si se desea
          },
        });

        console.log("Métodos disponibles en driver:", this.driver);

        this.driver.setSteps([
          {
            element: this.$refs.formulario1,
            popover: {
              title: 'Datos de perfil',
              description: 'Inicia agregando un logo y tu nombre completo.',
              position: 'bottom',
            }
          },
          {
            element: this.$refs.formulario2,
            popover: {
              title: 'Datos de contacto',
              description: 'Completa los datos de contacto de consultorio privado, recuerda que estos datos son importantes para la personalización de tu cuenta y asi poder comenzar a usar el sistema.',
              position: 'right'
            }
          },
          {
            element: this.$refs.formulario3,
            popover: {
              title: 'Datos de información académica',
              description: 'Completa los datos de información académica para que los pacientes puedan conocer más sobre tu formación, además que estos datos son indispensables para cumplir con la NOM-004-SSA3-2012.',
              position: 'right'
            }
          },
          {
            element: this.$refs.terminar,
            popover: {
              title: 'Finalizar configuración',
              description: 'Si ya has terminado de completar tus datos, haz clic en el botón "Continuar" de abajo para continuar.',
              position: 'right'
            }
          },
        ]);

        this.driver.drive();
      },


      verificarCompletitud() {
          if (this.driver) {
            this.driver.destroy();
            this.driver = null;
          }
        this.$router.push("/home");
      },
      getImageFromPhotoURL(photoURL) {
        if (photoURL.startsWith('user-')) {
          return `/images/${photoURL}.jpg`;
        }
        return photoURL;
      },

      handleFileUpload(event) {
        const file = event.target.files[0];
        if (file && file.type === 'image/jpeg') {
          this.selectedFile = file;
          const reader = new FileReader();
          reader.onload = (e) => {
            this.previewImage = e.target.result;
            this.$nextTick(() => {
              const image = this.$refs.image;
              this.cropper = new Cropper(image, {
                aspectRatio: 1,
                viewMode: 1,
                autoCropArea: 1,
              });
            });
          };
          reader.readAsDataURL(file);
        } else {
          this.notify('error', 'Solo se permiten archivos JPG');
          this.selectedFile = null;
          this.previewImage = null;
          this.$refs.fileInput.value = null;
        }
      },

      cropImage() {
        if (this.cropper) {
          const canvas = this.cropper.getCroppedCanvas({
            width: 200,
            height: 200,
          });
          canvas.toBlob(async (blob) => {
            this.selectedFile = blob;

            const user = auth.currentUser;


            if (!user) {
              this.notify("error", "Usuario no autenticado.");
              return;
            }

            try {
              this.openLoading();

              const formData = new FormData();
              formData.append("avatar", blob);
              formData.append("id", this.currentUser.mainId);

              const response = await axios.post(`${API}/subirAvatar`, formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              });
              if (response.data && response.data.filePath) {
                console.log("Imagen subida exitosamente:", response.data.filePath);
                await updateProfile(user, { photoURL: `${API}${response.data.filePath}` });
                this.notify("success", "Imagen de perfil actualizada exitosamente.");
                console.log("Imagen de perfil actualizada exitosamente:", response.data.filePath);

                const updatedUser = { ...user, photoURL: `${API}${response.data.filePath}`, mainId: this.currentUser.mainId };
                localStorage.setItem('user', JSON.stringify(updatedUser));
                this.currentUser = updatedUser;

                this.$refs.fileInput.value = null;
                this.selectedFile = null;
                this.previewImage = null;
                setTimeout(() => {
                  this.previewImage = `${API}${response.data.filePath}`;
                }, 333);

                // Emitir un evento global para notificar a otros componentes del cambio
                this.$root.$emit('userUpdated', updatedUser);
                this.$nextTick(() => {
                  this.cropper = null;
                });
              } else {
                this.notify("error", "Error al obtener la URL de la imagen del backend.");
              }
            } catch (error) {
              console.error("Error al subir la imagen al backend:", error);
              this.notify("error", `Error al subir la imagen: ${error.message}`);
            } finally {
              this.closeLoading();
            }
          }, 'image/jpeg');
          this.cropper.destroy();
          this.cropper = null;
        }
      },

      changePass() {
        if (!this.vEmpty(this.newPs, "Nueva contraseña") || !this.vEmpty(this.confirmPs, "Confirmar nueva contraseña")) {
          return;
        }
        if (this.newPs !== this.confirmPs) {
          this.notify("error", "Las contraseñas no coinciden.");
          return;
        }
        const user = auth.currentUser;
        if (!user) {
          this.notify("error", "Usuario no autenticado.");
          return;
        }

        this.openLoading();

        const credential = EmailAuthProvider.credential(user.email, this.currentPassword);

        reauthenticateWithCredential(user, credential)
          .then(() => {
            updatePassword(user, this.newPs)
              .then(() => {
                this.notify("success", "Contraseña actualizada exitosamente.");
                this.currentPassword = null;
                this.newPs = null;
                this.confirmPs = null;
              })
              .catch((error) => {
                console.error("Error al actualizar la contraseña:", error);
                this.notify("error", `Error al actualizar la contraseña: ${error.message}`);
              })
              .finally(() => {
                this.closeLoading();
              });
          })
          .catch((error) => {
            this.closeLoading();
            console.error("Error al reautenticar al usuario:", error);
            this.notify("error", "Contraseña actual inválida.");
          });
      },

      changeEmail() {
        if (!this.vEmail(this.userEmail)) {
          this.notify("error", "Formato de correo electrónico inválido.");
          return;
        }
        const user = auth.currentUser;
        if (!user) {
          this.notify("error", "Usuario no autenticado.");
          return;
        }

        this.openLoading();
        const credential = EmailAuthProvider.credential(user.email, this.currentPassword);

        reauthenticateWithCredential(user, credential)
          .then(() => {
            updateEmail(user, this.userEmail)
              .then(() => {
                this.notify("success", "Correo electrónico actualizado exitosamente.");
                this.userEmail = null;
                this.currentPassword = null;
              })
              .catch((error) => {
                console.error("Error al actualizar el correo electrónico:", error);
                this.notify("error", `Error al actualizar el correo electrónico: ${error.message}`);
              })
              .finally(() => {
                this.closeLoading();
              });
          })
          .catch((error) => {
            this.closeLoading();
            console.error("Error al reautenticar al usuario:", error);
            this.notify("error", "Contraseña actual inválida.");
          });
      },

      changeDisplayName() {
        if (!this.vEmpty(this.newDisplayName, "Nuevo nombre de usuario")) {
          return;
        }

        const user = auth.currentUser;
        if (!user) {
          this.notify("error", "Usuario no autenticado.");
          return;
        }

        this.openLoading();

        updateProfile(user, { displayName: this.newDisplayName })
          .then(() => {
            this.notify("success", "Nombre de usuario actualizado exitosamente.");
            const newDisplayName = this.newDisplayName;
            this.updateDisplayName(newDisplayName);
            this.$emit('displayNameChanged', newDisplayName);
          })
          .catch((error) => {
            console.error("Error al actualizar el nombre de usuario:", error);
            this.notify("error", `Error al actualizar el nombre de usuario: ${error.message}`);
          })
          .finally(() => {
            this.newDisplayName = null;
            this.closeLoading();
          });
      },

      sendVerify() {
        this.openLoading();
        sendEmailVerification(auth.currentUser)
          .then(() => {
            console.log("Correo de verificación enviado.");
            this.closeLoading();
            this.notify("success", "Correo de verificación enviado exitosamente.");
          })
          .catch((error) => {
            console.error("Error al enviar el correo de verificación:", error);
            this.closeLoading();
            this.notify("error", `Error al enviar el correo de verificación: ${error.code}`);
          });
      },
    },
  };
</script>
<style>
  .img-preview {
    max-width: 50%;
    height: auto;
    margin-top: 10px;
  }

  .img-container {
    max-width: 50%;
    height: auto;
    margin-top: 10px;
    position: relative;
  }

  .img-container img {
    display: block;
    max-width: 33% !important;
  }

  .responsive-img-container {
    width: 50%;
    height: auto;
    overflow: hidden;
    position: relative;
  }

  .circular-image {
    border-radius: 50%;
    width: 100%;
    max-width: 150px;
    /* Adjust as needed */
    height: auto;
    border-style: solid;
    border-color: #15e35c;
    border-width: medium;
  }
</style>